import { useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { createOneTimePaymentRequest } from "../../services/paymentService";

export function DebugToolOneTimePaymentSnippet() {
    const totalAmount: number = useSelector((state:AppState) => state.cart.totalAmount);

    function onShow() {
        const req = createOneTimePaymentRequest('<payment token ID>', totalAmount, uuidv4())
        return JSON.stringify(req, null, 1);
    }
    return (
        <div className="snippet-container">
            <pre>
                { onShow() }
            </pre>
        </div>
    )
}